import { LoadType } from '@tencent/ark-extensions';

export const TemplateMachineAuditConfig = {
    name: 'docs-component-template-machine-audit',
    loadType: LoadType.ON_DEMAND,
};
